import { REFERRAL_STRATEGY_OPTIONS, ReferralStrategyForEdit } from "../../../types";


export const MIXED_VALUE = '----' as const;

export const SHORTENED_LABELS: Record<
  ReferralStrategyForEdit | typeof MIXED_VALUE,
  string
> = {
  [ReferralStrategyForEdit.NONE]: 'None',
  [ReferralStrategyForEdit.INVALID_CHANGE]: 'Invalid',
  [ReferralStrategyForEdit.SELECTION_CHANGE]: 'Selection',
  [ReferralStrategyForEdit.ANY_CHANGE]: 'Any',
  [MIXED_VALUE]: MIXED_VALUE,
};

export function getReferralStrategyLabel(
  value: ReferralStrategyForEdit | typeof MIXED_VALUE
): string {
  return SHORTENED_LABELS[value] || String(value);
}

export function computeCategoryDisplayValue(
  strategies: ReferralStrategyForEdit[]
): ReferralStrategyForEdit | typeof MIXED_VALUE {
  if (strategies.length === 0) {
    return ReferralStrategyForEdit.NONE;
  }

  const firstStrategy = strategies[0];
  const allSame = strategies.every((strategy) => strategy === firstStrategy);

  return allSame ? firstStrategy : MIXED_VALUE;
}

export function createCategoryUpdates(
  keys: string[],
  strategy: ReferralStrategyForEdit
) {
  return keys.map((key) => ({
    id: key,
    referralStrategyForEdit: strategy,
  }));
}

export function getReferralStrategyOptions(
  displayValue: ReferralStrategyForEdit | typeof MIXED_VALUE
) {
  if (displayValue === MIXED_VALUE) {
    return [
      { value: MIXED_VALUE, label: MIXED_VALUE },
      ...REFERRAL_STRATEGY_OPTIONS,
    ];
  }
  return REFERRAL_STRATEGY_OPTIONS;
}

